const travelers = {
  text: '#01579b',
  borderBelowPageHeading: '#cfd8dc',
};

export default travelers;
